import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY_PREFIX = "profileSectionOpenState:"

export default class extends Controller {
  static values = { key: String }

  connect() {
    this.restore()
  }

  save() {
    try {
      window.localStorage.setItem(this.storageKey, String(this.element.open))
    } catch (error) {
      console.warn("Unable to save profile section state", error)
    }
  }

  restore() {
    try {
      const state = window.localStorage.getItem(this.storageKey)

      if (state === "true" || state === "false") {
        this.element.open = state === "true"
      } else if (state !== null) {
        window.localStorage.removeItem(this.storageKey)
      }
    } catch (error) {
      console.warn("Unable to restore profile section state", error)
    }
  }

  get storageKey() {
    return `${STORAGE_KEY_PREFIX}${this.keyValue}`
  }
}
